import React from 'react';
import { IconButton } from '@material-ui/core';
import { usePagination, UsePaginationProps } from '@material-ui/lab/Pagination';
import classNames from 'classnames';
import { LeftStrongIcon, RightStrongIcon } from 'src/monet/icons';

const DEFAULT_BOUNDARY_COUNT = 2;
const DEFAULT_BUTTON_SIZE = 25;

interface Props extends UsePaginationProps {
  size?: 'small' | 'default';
  containerClassName?: string;
}

export const Pagination = ({ size = 'default', containerClassName, ...props }: Props) => {
  const { items } = usePagination({
    ...props,
    boundaryCount: props.boundaryCount || DEFAULT_BOUNDARY_COUNT,
    siblingCount: props.siblingCount || DEFAULT_BOUNDARY_COUNT,
  });

  const isSizeSmall = size === 'small';

  return (
    <ul className={classNames('flex m-0 p-0', containerClassName)}>
      {items.map(({ page, type, selected, disabled, ...item }, index) => {
        let children = null;
        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          children = '…';
        } else if (type === 'page') {
          children = (
            <IconButton
              style={{
                fontWeight: 500,
                fontSize: 14,
                lineHeight: '17px',
                backgroundColor: selected ? 'rgba(16, 16, 16, 0.08)' : 'white',
                borderRadius: '50%',
                padding: isSizeSmall ? 8 : 12,
                marginLeft: index === 0 ? 0 : !isSizeSmall ? 8 : 4,
                width: isSizeSmall ? 24 : DEFAULT_BUTTON_SIZE,
                height: isSizeSmall ? 24 : DEFAULT_BUTTON_SIZE,
                color: '#101010',
              }}
              {...item}
            >
              {page}
            </IconButton>
          );
        } else {
          const isPrevious = type === 'previous';
          children = (
            <IconButton
              {...item}
              className={classNames({
                '!p-1': isSizeSmall,
                'opacity-40 pointer-events-none': disabled,
              })}
            >
              {isPrevious ? <LeftStrongIcon /> : <RightStrongIcon />}
            </IconButton>
          );
        }
        return (
          <li key={index} style={{ margin: 'auto 0' }}>
            {children}
          </li>
        );
      })}
    </ul>
  );
};
